<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} cuadre hotel
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="form-group col-lg-3">
                  <label>Rango de fechas</label>
                  <div class="input-group">
                    <span class="input-group-prepend">
                      <span class="input-group-text content__subhead__inputGrid__title">
                        <i class="far fa-calendar-alt"></i>
                      </span>
                    </span>
                    <input type="text" id="date_range" class="form-control content__subhead__inputGrid__input">
                  </div>
                </div>
                <!-- <div class="form-group col-lg-3">
                  <div class="custom-control custom-checkbox float-left">
                    <input type="checkbox" class="custom-control-input" ng-model="book.is_all" id="is_all" name="is_all"
                      ng-change="changeIsAll(book.is_all)">
                    <label class="custom-control-label p-t-3" for="is_all">Seleccionar todos</label>
                  </div>
                </div> -->
                <div class="form-group col-lg-6">
                  <label>Seleccionar hotel</label>
                  <ng-container *ngIf="hotelSelected == null">
                    <component-search-hotel [classSize]="'search-small'"
                      (selectedHotelEvent)="selectedHotelSearch($event)" class="w-100">
                    </component-search-hotel>
                  </ng-container>
                  <ng-container *ngIf="hotelSelected != null">
                    <div class="input-group">
                      <input type="text" class="form-control" value="{{hotelSelected.tradename}}" disabled>
                      <div class="input-group-append bg-custom b-0 removeClient">
                        <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                          (click)="removeHotel()">
                          <i class="fas fa-backspace w-100 f-s-12"></i>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="table-responsive">
                <table class="table mb-0 table-sm">
                  <thead class="thead-default">
                    <tr>
                      <th class="white-space-nowrap">
                        DATOS RESERVA
                      </th>
                      <ng-container *ngIf="bookings.length == 0">
                        <th class="w-20 f-s-10">
                          Habitación
                        </th>
                      </ng-container>
                      <ng-container *ngIf="bookings.length > 0">
                        <th class="w-20 f-s-10 white-space-nowrap">
                          <div class="custom-control custom-checkbox" style="min-height:1.2rem !important;">
                            <input class="custom-control-input" type="checkbox" id="all_data" [(ngModel)]="all_data"
                              [ngModelOptions]="{standalone: true}" (change)="selectedAllBooking()">
                            <label class="custom-control-label p-t-3" for="all_data">
                              Habitación <span class="f-s-7">(Todos)</span></label>
                          </div>
                        </th>
                      </ng-container>
                      <th class="f-s-10 w-5">#PAX</th>
                      <th class="f-s-10 w-5">#HAB</th>
                      <th class="f-s-10 w-10">Chck-in</th>
                      <th class="f-s-10 w-10">Chck-out</th>
                      <th class="f-s-10 w-10">#Noches </th>
                      <th class="f-s-10 w-10">Precio</th>
                      <th class="f-s-10 w-10">-S/Dscto</th>
                      <th class="f-s-10 w-10">S/Adicio</th>
                      <th class="f-s-10 w-10">Obs.</th>
                      <th class="f-s-10">Subtotal</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngIf="bookings.length == 0">
                      <tr>
                        <td colspan="7">
                          <i class="m-r-5"></i>Debe seleccionar el
                          hotel para cargar las reservas
                        </td>
                      </tr>
                    </ng-container>
                    <ng-container *ngIf="bookings.length > 0">
                      <tr *ngFor="let item of bookings; let i = index">
                        <td>
                          <p class="white-space-nowrap bold text-primary f-s-10 m-b-0">
                            COD:
                            {{item.code}}</p>
                          <p class="f-s-9 m-b-0">{{item.client_data.fullname}}, DOC:
                            {{item.client_data.document}}</p>
                          <div class="d-inline-block white-space-nowrap f-s-9 m-t-4" ng-if="data.booking_id !== null">
                            <span>
                              <i ng-if="data.booking_data.is_favorite" class="fas fa-star m-r-2 color-favorite"></i>
                              Reserva Asociada (<span class="bold">{{item.booking_data.code}}</span>
                              )</span>
                          </div>
                        </td>
                        <td style="padding: 0 !important;" colspan="11">
                          <ng-container *ngIf="item.detail_bedrooms.length == 0">
                      <tr>
                        <td colspan="7">
                          <i class="m-r-5"></i>No se encontaron
                          reservas de habitaciones pendientes
                        </td>
                      </tr>
                    </ng-container>
                    <ng-container *ngIf="item.detail_bedrooms.length > 0">
                      <ng-container *ngFor="let data of item.detail_bedrooms; let index_ = index">
                        <tr *ngIf="data.is_paid == false" [ngClass]="{'text-success bold': data.is_selected == true }">
                          <td class="w-20">
                            <div class="custom-control custom-checkbox">
                              <ng-container *ngIf="data.is_selected">
                                <input class="custom-control-input booking_transfers" type="checkbox"
                                id="booking_transfer_{{data.detail_id}}" checked="true" (change)="selectedBooking(data, i, index_)">                             
                              </ng-container>
                              <ng-container *ngIf="!data.is_selected">
                                <input class="custom-control-input booking_transfers" type="checkbox"
                                id="booking_transfer_{{data.detail_id}}" (change)="selectedBooking(data, i, index_)"> 
                              </ng-container>
                              <label class="custom-control-label p-t-3" for="booking_transfer_{{data.detail_id}}">
                                <span class="f-s-8"> {{data.typebedroom}}</span></label>
                            </div>

                          </td>
                          <td class="text-center w-5">
                            <!-- <input type="text" id="detailbedrooms_guests{{index_}}" numeric value="{{data.guests}}"
                              class="form-control sale__input text-center"> -->
                              {{data.guests}}
                          </td>
                          <td class="text-center w-5">
                            <!-- <input type="text" id="detailbedrooms_quantity{{index_}}" numeric value="{{data.quantity}}"
                              class="form-control sale__input text-center"> -->
                              {{data.quantity}}
                          </td>
                          <td class="w-10">
                            <!-- <input type="text" class="form-control sale__input text-center" id="date_checkin{{data.id}}"
                              value="{{data.date_checkin}}"> -->
                              {{data.date_checkin}}
                          </td>
                          <td class="w-10">
                            <!-- <input type="text" class="form-control sale__input text-center"
                              id="date_checkout{{data.id}}" value="{{data.date_checkout}}"> -->
                              {{data.date_checkout}}
                          </td>
                          <td class="w-10 text-center">
                            <!-- <input type="text" id="detailbedrooms_nights{{index_}}" numeric value="{{data.nights}}"
                              class="form-control sale__input text-center"> -->
                              {{data.nights}}
                          </td>
                          <td class="w-10">
                            <!-- <input type="text" id="detailbedrooms_price{{index_}}" numeric decimals="2"
                              value="{{data.price}}" class="form-control sale__input text-center"> -->
                              {{data.price}}
                          </td>
                          <td class="w-10">
                            <!-- <input type="text" id="detailbedrooms_discount{{index_}}" numeric decimals="2"
                              value="{{data.discount}}" class="form-control sale__input text-center text-danger"> -->
                              - {{data.discount}}
                          </td>
                          <td class="w-10">
                            <!-- <input type="text" id="detailbedrooms_additional{{index_}}" numeric decimals="2"
                              value="{{data.additional}}" class="form-control sale__input text-center text-success"> -->
                              + {{data.additional}}
                          </td>
                          <td class="w-10">
                            <!-- <input type="text" class="form-control sale__input text-center"
                              id="detailbedrooms_observation{{index_}}" value="{{data.observation}}"> -->
                              {{data.observation}}
                          </td>
                          <td class="text-center nowrap">
                            <span class="f-s-11">{{ data.subtotal | currency:'S/'}}</span>
                            <i *ngIf="data.is_selected" class="fas fa-check m-l-4"></i>                            
                          </td>
                        </tr>
                      </ng-container>
                    </ng-container>
                    </td>
                    </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-lg-12">
              <hr>
            </div>
            <div *ngIf="bookings.length > 0" class="col-lg-12 m-t-15">
              <div class="row justify-content-md-end">
                <div class="form-group col-lg-3">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text bold f-s-12">T.CUADRE S/. <span class="required-table"></span></div>
                    </div>
                    <input type="text" class="form-control form-control-sm text-right bold" id="total_block"
                      formControlName="total_block">
                  </div>
                </div>
                <!-- <div class="form-group col-lg-3">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text bold f-s-12 text-primary">PAGADO S/. <span
                          class="required-table"></span></div>
                    </div>
                    <input type="text" class="form-control form-control-sm text-right bold" id="total_paid"
                      formControlName="total_paid">
                  </div>
                </div>
                <div class="form-group col-lg-3">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text bold f-s-12 text-warning">SALDO S/. <span
                          class="required-table"></span></div>
                    </div>
                    <input type="text" class="form-control form-control-sm text-right bold" id="total_balance"
                      formControlName="total_balance">
                  </div>
                </div> -->
              </div>
            </div>

            <div class="form-group col-lg-12 form__footerBtn">
              <div class="text-right">
                <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                <button type="submit" class="btn btn-primary" [disabled]="item.invalid">
                  <i class="far fa-save m-r-5"></i>
                  <ng-container *ngIf="!isEdit">
                    Guardar
                  </ng-container>                  
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
